<script setup lang="ts">
import isEmpty from 'lodash/isEmpty'

const $props = defineProps<{
	organisation: App.Enums.OrganisationEnum
	organisations: App.Enums.OrganisationEnum[]
}>()

const errors = useProperty<{ [key: string | number]: string }>('errors')
const form = useForm<App.Data.Rider.BulkCreateRiderData>({
	method: 'POST',
	url: route('riders.bulk-store'),
	fields: {
		organisation: $props.organisation,
		import_file: undefined as File | undefined,
	},
})

function onFileChange(event: Event) {
	const target = event.target as HTMLInputElement
	form.fields.import_file = target.files?.[0]
}
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<page-container>
		<form class="space-y-5" @submit.prevent="form.submit">
			<div v-if="form.processing" class="flex items-center gap-2">
				<i-gg-alarm class="size-4 animate-bounce text-primary" />
				{{ t('app.importing') }}
			</div>
			<template v-else>
				<div class="space-y-2">
					<p>{{ t('app.import_riders_description') }}</p>

					<a :href="`/downloads/riders-example.xlsx?v=${Date.now()}`" target="_blank" class="flex items-center gap-2 text-primary hover:text-primary-700">
						<i-gg-import class="size-4" aria-hidden="true" />
						{{ t('app.download_example_file') }}
					</a>
				</div>

				<form-input-wrapper
					v-if="organisations.length > 1"
					:label="t('app.organisation.fallback')"
					for="organisation"
					:errors="form.errors.organisation"
				>
					<form-select
						id="organisation"
						v-model="form.fields.organisation"
						required
						disabled
					>
						<option v-for="organisationOption in $props.organisations" :key="organisationOption" :value="organisationOption">
							{{ t(`app.organisation.${organisationOption}`) }}
						</option>
					</form-select>
				</form-input-wrapper>

				<input type="file" accept=".xlsx" @change="onFileChange" />

				<div v-if="!isEmpty(errors)" class="max-h-[200px] overflow-y-scroll border border-red-600 bg-red-100 p-2 text-sm text-red-600">
					<ul class="list-inside list-disc">
						<li v-for="error in errors" :key="error">
							{{ error }}
						</li>
					</ul>
				</div>
			</template>

			<div class="flex justify-end space-x-4">
				<button-base variant="secondary" :href="route('riders.index')">
					{{ t('app.cancel') }}
				</button-base>

				<button-base type="submit" :loading="form.processing">
					{{ t('app.import') }}
				</button-base>
			</div>
		</form>
	</page-container>
</template>
